import React, { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import Spinner from './Spinner'
import { IStore } from '../interfaces/Store'
import { STATUS } from '../enums/common'

function PageSpinner(): ReactElement {
  const { status } = useSelector((state: IStore) => state.loadingReducer)
  if (status !== STATUS.pending) {
    return <></>
  }

  return (
    <div className="spinnerPage">
      <Spinner />
    </div>
  )
}

export default PageSpinner
